import img1 from "../assets/dominoz.svg";
import img2 from "../assets/tata.svg";
import img3 from "../assets/samsung.svg";
import img4 from "../assets/suzuki.svg";
import img5 from "../assets/venu.svg";
import img6 from "../assets/lake.svg";
import img0 from "../assets/apple.svg";
import img7 from "../assets/phillips.svg";
import img8 from "../assets/gov.svg";
import img9 from "../assets/yousta.svg";
import img10 from "../assets/pe.svg";
import img11 from "../assets/cs.svg";
import img12 from "../assets/tvs.svg";
import img13 from "../assets/magneta.svg";
import img14 from "../assets/daikin.svg";
import img15 from "../assets/shell.svg";
import img16 from "../assets/dtdc.svg";
import img17 from "../assets/marri.svg";
import { motion } from "framer-motion";

export default function Clients() {
  const logos = [img0, img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17];

  return (
    <section className="py-16  overflow-hidden">
      {/* Heading */}
       <h2 className="text-4xl font-bold text-center mb-10 text-gray-800">Our Clients</h2>

      <div className="relative w-full overflow-hidden">
        <motion.div
          className="flex gap-16 items-center"
          animate={{ x: ["0%", "-100%"] }}
          transition={{
            repeat: Infinity,
            duration: 14,
            ease: "linear",
          }}
        >
          {[...logos, ...logos].map((logo, i) => (
            <div
              key={i}
              className="flex items-center justify-center min-w-[150px] min-h-[150px]"
            >
              <img
                src={logo}
                alt={`client-${i}`}
                className="w-full h-full object-contain"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
